import ButtonDownloadFiles from './ButtonDownloadFiles';

export default ButtonDownloadFiles;
